import React from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faSave,
  faTrash,
  faWindowRestore,
} from '@fortawesome/sharp-regular-svg-icons'
import { ActionIcon, Menu, rem, Tooltip, useMantineTheme } from '@mantine/core'
import { useTranslation } from 'react-i18next'

import type { LocalStorageFilterControlProps } from './filter-control-bar'

const LocalStorageFilterControl = ({
  sortFilter,
  actionIconSize = 'lg',
}: LocalStorageFilterControlProps): React.ReactElement => {
  const { t } = useTranslation('common')
  const theme = useMantineTheme()
  const color = theme.colors[theme.primaryColor][6]

  return (
    <Menu
      position="top-end"
      width={220}
      withinPortal
      trigger="hover"
    >
      <Menu.Target>
        <div>
          <ActionIcon
            size={actionIconSize}
            variant="filled"
            color={color}
          >
            <FontAwesomeIcon
              icon={faSave}
              fontSize={theme.fontSizes[actionIconSize]}
            />
          </ActionIcon>
        </div>
      </Menu.Target>

      <Menu.Dropdown>
        <Tooltip
          // label={t('table_current_filter_equals_saved')}
          label={i18n.t(
            'table_current_filter_equals_saved',
            'Der aktuell ausgewählte Filter entspricht Ihrem gespeicherten Filter',
          )}
          withinPortal
          disabled={!sortFilter.activeFilterEqualsLocalStorage}
        >
          <div>
            <Menu.Item
              disabled={sortFilter.activeFilterEqualsLocalStorage}
              onClick={() => sortFilter.saveFilterToLocalStorage()}
              icon={
                <FontAwesomeIcon
                  icon={faSave}
                  style={{ width: rem(16), height: rem(16) }}
                  color={color}
                />
              }
            >
              {/* {t('table_save_current_state_filter')} */}
              {i18n.t(
                'table_save_current_state_filter',
                'Aktuelle Filterauswahl im Browser speichern',
              )}
            </Menu.Item>
          </div>
        </Tooltip>

        <Tooltip
          disabled={
            sortFilter.hasValidLocalStorageFilter
              ? !sortFilter.activeFilterEqualsLocalStorage
              : false
          }
          label={
            !sortFilter.hasValidLocalStorageFilter
              ? i18n.t(
                  'no_local_storage_filter',
                  'Derzeit ist keine Filterauswahl im Browser gespeichert',
                ) // t('no_local_storage_filter')
              : sortFilter.activeFilterEqualsLocalStorage
                ? i18n.t(
                    'table_current_filter_equals_saved',
                    'Der aktuell ausgewählte Filter entspricht Ihrem gespeicherten Filter',
                  ) //t('table_current_filter_equals_saved')
                : undefined
          }
        >
          <div>
            <Menu.Item
              disabled={
                sortFilter.activeFilterEqualsLocalStorage ||
                !sortFilter.hasValidLocalStorageFilter
              }
              onClick={() => sortFilter.loadLocalStorageFilter()}
              icon={
                <FontAwesomeIcon
                  icon={faWindowRestore}
                  style={{ width: rem(16), height: rem(16) }}
                  color={color}
                />
              }
            >
              {i18n.t(
                'table_load_local_storage_filter',
                'Im Browser gespeicherte Filterauswahl laden',
              )}
              {/* {t('table_load_local_storage_filter')} */}
            </Menu.Item>
          </div>
        </Tooltip>

        <Tooltip
          disabled={sortFilter.hasValidLocalStorageFilter}
          //label={t('no_local_storage_filter')}
          label={i18n.t(
            'no_local_storage_filter',
            'Derzeit ist keine Filterauswahl im Browser gespeichert',
          )}
        >
          <div>
            <Menu.Item
              disabled={!sortFilter.hasValidLocalStorageFilter}
              onClick={() => sortFilter.clearLocalStorageFilter()}
              icon={
                <FontAwesomeIcon
                  icon={faTrash}
                  style={{ width: rem(16), height: rem(16) }}
                  color="red"
                />
              }
            >
              {/* {t('table_reset_storage_filter')} */}
              {i18n.t(
                'table_reset_storage_filter',
                'Im Browser gespeicherte Filterauswahl löschen',
              )}
            </Menu.Item>
          </div>
        </Tooltip>
      </Menu.Dropdown>
    </Menu>
  )
}

export default LocalStorageFilterControl
